var _rect, _path, _g, _path2, _g2, _path3, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 249,
    viewBox: "0 0 237 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 237,
    width: 249,
    height: 237,
    rx: 60,
    transform: "rotate(90 237 0)",
    fill: "#80858F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_387_302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 49,
    width: 113,
    height: 111
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 160C88.7236 100.181 76.2673 61.0753 62.3238 49H110.197C151.098 72.036 141.182 132.598 131.112 160H27Z",
    fill: "#E6E6E6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_387_302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -42,
    y: -4,
    width: 203,
    height: 203,
    rx: 15,
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_387_302)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_387_302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 69,
    width: 113,
    height: 111
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57 180C118.724 120.181 106.267 81.0753 92.3238 69H140.197C181.098 92.036 171.182 152.598 161.112 180H57Z",
    fill: "#E0E0E0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_387_302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: 104.723,
    width: 177.81,
    height: 177.81,
    rx: 15,
    transform: "rotate(-38.5141 -35 104.723)",
    fill: "#F1F1F1"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_387_302)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_387_302",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 89,
    width: 113,
    height: 111
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87 200C148.724 140.181 136.267 101.075 122.324 89H170.197C211.098 112.036 201.182 172.598 191.112 200H87Z",
    fill: "#E0E0E0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_387_302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 205.768,
    width: 177.81,
    height: 177.81,
    rx: 15,
    transform: "rotate(-72.7023 6 205.768)",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_387_302",
    x: 33,
    y: 49,
    width: 153,
    height: 151,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_387_302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_387_302",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_387_302",
    x: 63,
    y: 69,
    width: 153,
    height: 151,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_387_302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_387_302",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4c0d8b24d9982b62086e87cf84554593.svg";
export { ForwardRef as ReactComponent };